/** Отображает логин пользователя в верхней части приложения. */
export const showUserBadge = (login: string) => {
    const badge = document.getElementById("userLoginBadge");
    const nameEl = document.getElementById("userLoginName");

    const userDropdownBtn = document.getElementById('userDropdownBtn');
    const userDropdownMenu = document.getElementById("userDropdownMenu");

    if ( 
        (!(badge instanceof HTMLElement) ||
        !(nameEl instanceof HTMLElement)) ||
        !( userDropdownMenu instanceof HTMLDivElement) ||
        !( userDropdownBtn instanceof HTMLButtonElement)
    )
      return;
    
    nameEl.textContent = login;
    badge.style.display = "flex";
};